import { FavoriteIcon } from '@/components/icons/svg-icons'
import { Button } from '@nf/ui'
import { useThrottleClick } from '@nf/utils-common/hooks';
import { useRef, useState } from 'react';
import FlyIcon from '../fly-icon/fly-icon';
import { useAppearanceStore } from '@/store/appearance';
import { ViewEnum } from '@/types';
import { useAnalyseAttribute } from '@/features/next-analyse';
import { useParams } from 'next/navigation';

const selectors = [
	'.side-features__item .icon.icon--favorite',
	'.pos_relative .icon.icon--favorite'
];

// 該元素是否可見
const elementIsVisibleInViewport = (el: Element) => {
	const { top, left, bottom, right } = el.getBoundingClientRect();
	const { innerHeight, innerWidth } = window;
	return top >= 0 && left >= 0 && bottom <= innerHeight && right <= innerWidth;
};

// 依照list的順序篩選出可見元素
function findVisibleIcon(selectors: string[]) {
	for (let i = 0; i < selectors.length; i++) {
		const icon = document.querySelector(selectors[i]);
		if (icon && elementIsVisibleInViewport(icon)) {
			return icon;
		}
	}
	return null;
}

// FlyIcon hook
const useMyfavoriteFlyIcon = () => {
	const view = useAppearanceStore(state => state.view);
	const [showFlyIcon, setShowFlyIcon] = useState(false);
	const [targetElement, setTargetElement] = useState<Element | null>(null);
	const elementRef = useRef<HTMLElement>(null);

	const triggerFlyAnimation = () => {
		// mars 版本才觸發動畫
		if (ViewEnum.mars === view) {
			const targetElement = findVisibleIcon(selectors);
			if (targetElement) {
				setTargetElement(targetElement);
				setShowFlyIcon(true);
			}
		}
	};

	const handleAnimationEnd = () => {
		setShowFlyIcon(false);
	};

	return {
		selectors,
		showFlyIcon,
		targetElement,
		elementRef,
		triggerFlyAnimation,
		handleAnimationEnd,
		findVisibleIcon
	}
}

interface MyFavouritesButtonProps {
	isSelected: boolean;
	onToggleMyFavoriteButton(): void;
}

export const MyFavouritesButton = ({
	isSelected,
	onToggleMyFavoriteButton
}: MyFavouritesButtonProps) => {
	const {
		showFlyIcon,
		targetElement,
		elementRef,
		triggerFlyAnimation,
		handleAnimationEnd,
	} = useMyfavoriteFlyIcon();
	const params = useParams();
	const isSingleMatchPage = params.matchId !== undefined;
	const taggedElement = useAnalyseAttribute(isSingleMatchPage ? 'use-add-my-favorites-from-single-match' : 'use-add-my-favorites');

	const onClick = useThrottleClick(() => {
		onToggleMyFavoriteButton();

		// 若已加入最愛不觸發動畫
		!isSelected && triggerFlyAnimation();
	}, 500);

	
	return (
		<>
			<Button			
				variant={'icon'}
				className="btn--favorite"
				data-active={isSelected}
				onClick={onClick}
				ref={taggedElement}
			>
				<span ref={elementRef}>
					<FavoriteIcon />
				</span>
				
			</Button>
			{showFlyIcon ? (
				<FlyIcon
					getStartElement={() => elementRef.current}
					getTargetElement={() => targetElement}
					onAnimationEnd={handleAnimationEnd}
					duration={500}
				>
					
					<span style={{ color: 'var(--colors-warning-base)' }}><FavoriteIcon /></span>
				</FlyIcon>
			): null}
		</>
		
	)
}